import React from 'react';
import classnames from 'classnames';
import bemBlock from '@gik/core/utils/bemBlock';

export interface ITestimonialsCarouselCardProps extends React.HTMLAttributes<HTMLDivElement> {
  name: string;
  quote: string;
  title: string;
  avatar?: SvgrComponent;
  location: string;
}

export default function TestimonialsCarouselCard({
  className,
  avatar,
  quote,
  name,
  title,
  location,
}: ITestimonialsCarouselCardProps): React.ReactElement {
  const Avatar = avatar;

  const bem = bemBlock('testimonials-carousel-card');
  const blockClasses = classnames([bem(), className || '']);

  return (
    <div className={blockClasses}>
      <div className={bem('quote')}>&quot;{quote}&quot;</div>
      <div className={bem('person-row')}>
        <div className={bem('person')}>
          <div className={bem('avatar')}>
            <Avatar />
          </div>
          <div className={bem('info')}>
            <div className={bem('name')}>{name}</div>
            <div className={bem('title')}>{title}</div>
            <div className={bem('location')}>{location}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
